import styles from './SegmentedControl.module.scss';

export interface Segment {
  value: string;
  icon: React.ReactNode;
  activeIcon?: React.ReactNode;
  ariaLabel: string;
}

export interface SegmentedControlProps {
  segments: Segment[];
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  className?: string;
}

export const SegmentedControl = ({
  segments,
  value,
  onChange,
  disabled = false,
  className = '',
}: SegmentedControlProps) => {
  return (
    <div
      className={`${styles.container} ${disabled ? styles.disabled : ''} ${className}`}
      role="radiogroup"
    >
      {segments.map((segment) => {
        const isActive = segment.value === value;
        return (
          <button
            key={segment.value}
            type="button"
            role="radio"
            aria-checked={isActive}
            aria-label={segment.ariaLabel}
            className={`${styles.segment} ${isActive ? styles.active : ''}`}
            disabled={disabled}
            onClick={() => {
              if (!isActive) {
                onChange(segment.value);
              }
            }}
          >
            <span className={styles.iconWrapper}>
              {isActive && segment.activeIcon ? segment.activeIcon : segment.icon}
            </span>
          </button>
        );
      })}
    </div>
  );
};
